<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">{{ pageTitle }}</h4>
          </div>
          <div class="card-body">
            <!-- 등록 — 화주 한 명에 여러 장(2026-10-04 YZY) -->
            <div class="border rounded p-2 mb-3 bg-light">
              <div class="d-flex align-items-center flex-wrap inv-lic__gap">
                <span class="font-weight-bold">➕ 上传营业执照(사업자등록증 등록)</span>
                <label class="mb-0 small">货主(화주)</label>
                <input v-model.trim="newCompany" list="invLicCompanies" class="form-control form-control-sm" style="width:200px">
                <datalist id="invLicCompanies">
                  <option v-for="c in allCompanyids" :key="'dl' + c" :value="c"></option>
                </datalist>
                <label class="mb-0 small">상호명</label>
                <input v-model.trim="newLabel" class="form-control form-control-sm" style="width:180px">
                <label class="mb-0 small">영문상호명</label>
                <input v-model.trim="newLabelEn" class="form-control form-control-sm" style="width:180px">
                <label class="mb-0 small">대표자</label>
                <input v-model.trim="newRep" class="form-control form-control-sm" style="width:110px">
                <label class="btn btn-sm btn-primary mb-0" :class="{ disabled: !newCompany || busy }">
                  选择图片并上传(이미지 선택·등록)
                  <input type="file" accept="image/png,image/jpeg" class="d-none" :disabled="!newCompany || busy" @change="onAdd">
                </label>
                <b-spinner v-if="busy" small></b-spinner>
                <span v-if="extracting" class="small text-info">正在从图片识别…(이미지에서 읽는 중)</span>
              </div>
              <small class="text-muted d-block mt-1">
                上传后自动从图片识别상호명·영문상호명·대표자·地址(英文)，空着的栏会自动填写，可以修改。收件人默认用영문상호명，邮箱·电话请手动填写(올리면 이미지에서 읽어 빈 칸을 채웁니다. 주소는 영문으로 바꿔 넣고, 收件人 은 영문상호명이 기본값. 고칠 수 있습니다. 증에 영문상호가 없으면 빈칸).
              </small>
              <small class="text-muted d-block">
                一个货主可以登记多张营业执照，生成箱单发票时选择(한 화주에 여러 장 등록할 수 있고, 箱单发票 만들 때 그중에서 고릅니다). 只支持 PNG/JPG(PNG·JPG 만).
              </small>
            </div>

            <div class="d-flex align-items-center flex-wrap inv-lic__gap mb-2">
              <!-- 화주 고르기 + 글자 검색(화주·상호명·영문상호명·대표자·收件人 부분일치) — 2026-10-04 YZY -->
              <label class="mb-0 small">货主(화주)</label>
              <select v-model="filter" class="form-control form-control-sm" style="width:200px">
                <option value="">全部(전체)</option>
                <option v-for="c in listedCompanies" :key="'lf' + c" :value="c">{{ c }}</option>
              </select>
              <label class="mb-0 small">搜索(검색)</label>
              <input v-model.trim="search" type="search" class="form-control form-control-sm" style="width:240px" title="货主·상호명·영문상호명·대표자·收件人">
              <span class="small text-muted">显示 {{ filtered.length }} / 共 {{ licenses.length }} 张 · {{ listedCompanies.length }} 个货主(화주)</span>
              <b-button size="sm" variant="outline-secondary" :disabled="loading" @click="load">刷新(새로고침)</b-button>
              <b-button size="sm" variant="outline-primary" :disabled="loading || busy || !filtered.length" @click="openBulk">批量添加邮箱(이메일 일괄 추가)</b-button>
              <b-spinner v-if="loading" small></b-spinner>
            </div>
            <div v-if="error" class="text-danger small mb-2">{{ error }}</div>

            <div class="table-responsive inv-lic__table">
              <table class="table table-sm table-bordered mb-0 small">
                <thead class="thead-light">
                  <tr>
                    <th>货主(화주)</th><th style="min-width:100px">图片(이미지)</th><th style="min-width:120px">상호명</th><th style="min-width:130px">영문상호명</th><th style="min-width:100px">대표자</th><th style="min-width:220px">收件信息(수취정보 — 箱单发票 收货人)</th><th>文件(파일)</th><th style="min-width:110px">更新(수정일)</th><th style="min-width:90px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="l in filtered" :key="l._id">
                    <td class="font-weight-bold">{{ l.companyid }}<div v-if="l._no > 1" class="text-muted font-weight-normal">第 {{ l._no }} 张</div></td>
                    <td>
                      <img v-if="thumbs[l._id]" :src="thumbs[l._id]" class="inv-lic__thumb" alt="" @click="preview = thumbs[l._id]">
                      <b-button v-else size="sm" variant="link" class="p-0" @click="loadThumb(l._id)">查看(보기)</b-button>
                      <!-- 「识别」 은 이미지 바로 아래(2026-10-04 YZY) -->
                      <div class="mt-1">
                        <b-button size="sm" variant="outline-info" class="text-nowrap" :disabled="busy" title="从图片重新识别，覆盖상호명·영문상호명·대표자·地址(이미지에서 다시 읽어 덮어씀)" @click="extract(l._id, true)">识别(읽기)</b-button>
                      </div>
                    </td>
                    <td v-for="f in textFields" :key="f">
                      <input :value="l[f] || ''" class="form-control form-control-sm" :disabled="busy" @change="saveText(l, f, $event.target.value)">
                    </td>
                    <!-- 收件人 · 地址(영문 — 증에서 읽어 영문으로) · 邮箱 · 电话. 빈 값은 빈칸 그대로 — placeholder 를 두면 회색 글씨가 값처럼 보여 안 채운 칸을 못 가린다(2026-10-04 YZY) -->
                    <td>
                      <div v-for="f in rcptFields" :key="f.k" class="d-flex align-items-center mb-1">
                        <span class="text-muted inv-lic__rlabel">{{ f.t }}</span>
                        <textarea v-if="f.k === 'addrEn'" :value="l[f.k] || ''" rows="2" class="form-control form-control-sm" :disabled="busy" @change="saveText(l, f.k, $event.target.value)"></textarea>
                        <input v-else :value="l[f.k] || ''" class="form-control form-control-sm" :disabled="busy" @change="saveText(l, f.k, $event.target.value)">
                      </div>
                    </td>
                    <td>{{ l.name }} <span class="text-muted">{{ l.width }}×{{ l.height }}</span></td>
                    <td>{{ fmtDate(l.updatedAt) }}<div class="text-muted text-break">{{ l.updatedBy }}</div></td>
                    <td>
                      <label class="btn btn-sm btn-outline-secondary mb-1 text-nowrap" :class="{ disabled: busy }">
                        更换(교체)
                        <input type="file" accept="image/png,image/jpeg" class="d-none" :disabled="busy" @change="onReplace(l, $event)">
                      </label>
                      <div><b-button size="sm" variant="outline-danger" class="text-nowrap" :disabled="busy" @click="remove(l)">删除(삭제)</b-button></div>
                    </td>
                  </tr>
                  <tr v-if="!filtered.length"><td colspan="9" class="text-center text-muted">没有登记的营业执照(등록된 사업자등록증이 없습니다)</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal :visible="!!preview" size="xl" hide-footer title="营业执照(사업자등록증)" @hidden="preview = ''">
      <img v-if="preview" :src="preview" class="img-fluid" alt="">
    </b-modal>

    <!-- 邮箱 일괄 추가(2026-10-06 YZY) — 이메일 하나를 고른 장들의 邮箱 맨 앞에 붙인다. 이미 있으면 건너뜀. 바뀌기 전 값은 서버가 이력에 남긴다 -->
    <b-modal :visible="bulk.show" size="xl" title="批量添加邮箱(이메일 일괄 추가)" no-close-on-backdrop @hidden="bulk.show = false">
      <div class="d-flex align-items-center flex-wrap inv-lic__gap mb-2">
        <label class="mb-0 small">邮箱 E-MAIL</label>
        <input v-model.trim="bulk.email" class="form-control form-control-sm" style="width:280px" :disabled="bulk.busy" @input="bulk.preview = null">
        <span v-if="bulk.email && !bulkEmailOk" class="small text-danger">邮箱格式不正确(이메일 형식이 아닙니다)</span>
      </div>
      <small class="text-muted d-block mb-2">
        加在每张营业执照收件信息「邮箱」的最前面，用逗号隔开；已经有这个邮箱的不会重复添加(각 장 邮箱 맨 앞에 쉼표로 붙입니다. 이미 들어 있는 장은 건너뜁니다).
      </small>

      <template v-if="!bulk.preview">
        <div class="d-flex align-items-center inv-lic__gap mb-1 small">
          <b-form-checkbox :checked="bulkAllChecked" :disabled="bulk.busy" @change="bulkCheckAll">全选(전체 선택)</b-form-checkbox>
          <span class="text-muted">已选 {{ bulkSelectedIds.length }} / {{ bulk.targets.length }} 张(선택 / 대상 — 当前列表 지금 목록 기준)</span>
        </div>
        <div class="inv-lic__table inv-lic__bulk">
          <table class="table table-sm table-bordered mb-0 small">
            <thead class="thead-light"><tr><th style="width:40px"></th><th>货主(화주)</th><th>상호명</th><th>邮箱(现在 지금)</th></tr></thead>
            <tbody>
              <tr v-for="t in bulk.targets" :key="'bt' + t._id">
                <td><b-form-checkbox v-model="bulk.checked[t._id]" :disabled="bulk.busy"></b-form-checkbox></td>
                <td>{{ t.companyid }}<span v-if="t._no > 1" class="text-muted"> · 第 {{ t._no }} 张</span></td>
                <td>{{ t.label }}</td>
                <td class="text-break">{{ t.email }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <template v-else>
        <div class="small mb-1">
          <b class="text-primary">将修改 {{ bulk.preview.changes.length }} 张(바뀔 장)</b>
          <span v-if="bulkDupCount" class="ml-2 text-muted">· 已有该邮箱跳过 {{ bulkDupCount }} 张(이미 있어서 건너뜀)</span>
          <span v-if="bulkLongCount" class="ml-2 text-danger">· 太长跳过 {{ bulkLongCount }} 张(300자 넘어 건너뜀)</span>
        </div>
        <div class="inv-lic__table inv-lic__bulk">
          <table class="table table-sm table-bordered mb-0 small">
            <thead class="thead-light"><tr><th>货主(화주)</th><th>상호명</th><th>修改前(변경 전)</th><th>修改后(변경 후)</th></tr></thead>
            <tbody>
              <tr v-for="c in bulk.preview.changes" :key="'bp' + c.id">
                <td>{{ c.companyid }}<span v-if="bulkTargetOf(c.id)._no > 1" class="text-muted"> · 第 {{ bulkTargetOf(c.id)._no }} 张</span></td>
                <td>{{ bulkTargetOf(c.id).label }}</td>
                <td class="text-break text-muted">{{ c.before }}</td>
                <td class="text-break">{{ c.after }}</td>
              </tr>
              <tr v-if="!bulk.preview.changes.length"><td colspan="4" class="text-center text-muted">没有要修改的(바뀔 장이 없습니다)</td></tr>
            </tbody>
          </table>
        </div>
      </template>
      <div v-if="bulk.result" class="mt-2 small font-weight-bold text-success">{{ bulk.result }}</div>

      <template #modal-footer>
        <b-spinner v-if="bulk.busy" small></b-spinner>
        <b-button v-if="bulk.preview && !bulk.result" size="sm" variant="outline-secondary" :disabled="bulk.busy" @click="bulk.preview = null">返回修改(다시 고르기)</b-button>
        <b-button v-if="!bulk.preview" size="sm" variant="primary" :disabled="bulk.busy || !bulkEmailOk || !bulkSelectedIds.length" @click="bulkRun(true)">预览(미리보기)</b-button>
        <b-button v-else-if="!bulk.result" size="sm" variant="primary" :disabled="bulk.busy || !bulk.preview.changes.length" @click="bulkRun(false)">确认添加(적용)</b-button>
        <b-button size="sm" variant="outline-secondary" :disabled="bulk.busy" @click="bulk.show = false">关闭(닫기)</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { coupassMenuTitle } from './coupassMenu';
import { shrinkImage } from './invoiceImage';

// 올린 시각 — createdAt, 없으면 _id 의 ObjectId 시각('license:<화주>:<ObjectId>'), 그것도 없으면 0(맨 아래)
function uploadedTime(l) {
  const t = l.createdAt ? new Date(l.createdAt).getTime() : NaN;
  if (!isNaN(t)) return t;
  const m = String(l._id || '').match(/:([0-9a-f]{24})$/);
  return m ? parseInt(m[1].slice(0, 8), 16) * 1000 : 0;
}

// 이메일 형식 — 서버(INVOICE_EMAIL_RE)와 같은 규칙. 최종 판정은 서버
const BULK_EMAIL_RE = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;

// 营业执照管理 — 화주별 사업자등록증(여러 장). 저장은 /api/coupassInvoiceImage/*(server.js 「箱单发票 이미지」 구역).
// 옛 구조(화주당 한 장, _id 'license:<companyid>')도 그대로 이 목록에 「첫 장」으로 나온다.
export default {
  name: 'InvoiceLicenseList',
  data() {
    return {
      pageTitle: coupassMenuTitle('logis.invoicelicenses'),
      list: [],
      loading: false,
      busy: false,
      error: '',
      filter: '',
      search: '',
      newCompany: '',
      newLabel: '',
      newLabelEn: '',
      newRep: '',
      textFields: ['label', 'labelEn', 'representative'], // 상호명(옛 「이름」)·영문상호명·대표자
      // 수취정보 — 箱单发票 收货人(Messrs) 기본값. 收件人 은 이미지 읽을 때 영문상호명으로 채워 저장, 地址 는 증에서 읽어 영문으로 바꾼 것
      rcptFields: [
        { k: 'recipient', t: '收件人' },
        { k: 'addrEn', t: '地址' },
        { k: 'email', t: '邮箱' },
        { k: 'tel', t: '电话' }
      ],
      extracting: false,
      allCompanyids: [],
      thumbs: {},
      preview: '',
      // 邮箱 일괄 추가 — targets = 창을 열 때의 목록(검색·화주 거른 그대로), checked[_id] = 대상 여부(기본 전체)
      bulk: { show: false, email: '', targets: [], checked: {}, preview: null, result: '', busy: false }
    };
  },
  computed: {
    // 올린 순서 — 마지막에 올린 것이 맨 위(2026-10-04 YZY). 第N张 은 화주 안에서 먼저 올린 순(옛 한 장이 첫 장)
    licenses() {
      const all = this.list.filter(x => x.kind === 'license').map(l => Object.assign({ _t: uploadedTime(l) }, l));
      const no = {};
      const seen = {};
      all.slice().sort((a, b) => (a.companyid === b.companyid ? (a._t - b._t || (a._id < b._id ? -1 : 1)) : (a.companyid < b.companyid ? -1 : 1)))
        .forEach(l => { seen[l.companyid] = (seen[l.companyid] || 0) + 1; no[l._id] = seen[l.companyid]; });
      return all.sort((a, b) => b._t - a._t || (a._id < b._id ? 1 : -1)).map(l => Object.assign({ _no: no[l._id] }, l));
    },
    listedCompanies() { return [...new Set(this.licenses.map(l => l.companyid))]; },
    // 화주는 고른 것과 같은 것만, 검색어는 화주·상호명·영문상호명·대표자·收件人 중 하나에 들어 있으면
    filtered() {
      const q = this.search.toLowerCase();
      return this.licenses.filter(l => {
        if (this.filter && l.companyid !== this.filter) return false;
        if (!q) return true;
        return ['companyid', 'label', 'labelEn', 'representative', 'recipient'].some(k => String(l[k] || '').toLowerCase().includes(q));
      });
    },
    bulkEmailOk() { return BULK_EMAIL_RE.test(this.bulk.email); },
    bulkSelectedIds() { return this.bulk.targets.filter(t => this.bulk.checked[t._id]).map(t => t._id); },
    bulkAllChecked() { return !!this.bulk.targets.length && this.bulkSelectedIds.length === this.bulk.targets.length; },
    bulkDupCount() { return this.bulk.preview ? this.bulk.preview.skipped.filter(x => x.reason === 'dup').length : 0; },
    bulkLongCount() { return this.bulk.preview ? this.bulk.preview.skipped.filter(x => x.reason === 'tooLong').length : 0; }
  },
  mounted() {
    document.title = this.pageTitle;
    this.load();
    this.loadCompanies();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/list', {});
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '读取失败');
        this.list = data.list || [];
      } catch (e) {
        console.error('营业执照 목록 실패:', e);
        this.error = '读取失败(읽기 실패): ' + e.message;
      } finally {
        this.loading = false;
      }
    },
    async loadCompanies() {
      try {
        const { data } = await axios.post('/api/getcompanyids', {});
        const list = (data && data.result) || [];
        // 쿠패스 화주만(창고관리 화주 목록과 같은 기준 — auth.showimport)
        this.allCompanyids = [...new Set(list.filter(u => u.auth && u.auth.showimport).map(u => u.companyid).filter(Boolean))].sort();
      } catch (e) {
        console.error('companyid 목록 실패:', e);
      }
    },
    async loadThumb(id) {
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/get', { id });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '读取失败');
        const doc = data.image;
        if (doc && doc.data) this.$set(this.thumbs, id, 'data:' + doc.type + ';base64,' + doc.data);
      } catch (e) {
        console.error('营业执照 읽기 실패:', e);
        alert('读取失败(읽기 실패): ' + e.message);
      }
    },
    // body = 저장 요청에 더할 것(id 또는 add). 성공하면 목록을 다시 읽는다
    async upload(file, body) {
      this.busy = true;
      try {
        const img = await shrinkImage(file, 'license');
        const { data } = await axios.post('/api/coupassInvoiceImage/save', Object.assign({ kind: 'license' }, body, img));
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        const id = data.image && data.image._id;
        if (id) this.$set(this.thumbs, id, 'data:' + img.type + ';base64,' + img.data);
        await this.load();
        // 이미지에서 상호명·영문상호명·대표자를 읽어 빈 칸만 채운다 — 실패해도 등록은 된 것
        if (id) this.extract(id, false);
        return true;
      } catch (e) {
        console.error('营业执照 저장 실패:', e);
        alert('保存失败(저장 실패): ' + e.message);
        return false;
      } finally {
        this.busy = false;
      }
    },
    async onAdd(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file || !this.newCompany) return;
      // 收件人 = 영문상호명(적었으면 같이 저장)
      const body = { companyid: this.newCompany, add: true, label: this.newLabel, labelEn: this.newLabelEn, representative: this.newRep };
      if (this.newLabelEn) body.recipient = this.newLabelEn;
      const ok = await this.upload(file, body);
      // 한 장 올리면 货主 칸도 비운다(2026-10-04 YZY)
      if (ok) { this.newCompany = ''; this.newLabel = ''; this.newLabelEn = ''; this.newRep = ''; }
    },
    async onReplace(l, e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = '';
      if (!file) return;
      await this.upload(file, { companyid: l.companyid, id: l._id });
    },
    // overwrite=false: 빈 칸만 채움(올린 직후) / true: 읽은 값으로 덮어씀(「识别」 버튼)
    async extract(id, overwrite) {
      if (overwrite && !confirm('从图片重新识别并覆盖상호명·영문상호명·대표자·地址?(이미지에서 다시 읽어 덮어쓸까요? 邮箱·电话 는 그대로)')) return;
      this.extracting = true;
      if (overwrite) this.busy = true;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/extract', { id, overwrite: !!overwrite });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '识别失败');
        await this.load();
      } catch (e) {
        console.error('营业执照 판독 실패:', e);
        alert('识别失败，请手动填写(이미지 읽기 실패 — 직접 적어 주세요): ' + e.message);
      } finally {
        this.extracting = false;
        if (overwrite) this.busy = false;
      }
    },
    async saveText(l, field, value) {
      const v = String(value || '').trim();
      const body = { id: l._id, [field]: v };
      // 영문상호명 ↔ 收件人 (2026-10-04 YZY) — 영문상호명을 고치면 收件人 이 비었거나 지금까지 같았을 때 따라 바뀐다.
      // 收件人 을 고치면 영문상호명이 비었을 때만 채운다 — 收件人 을 따로 바꾸는 길을 남겨 두려고(바꾼 收件人 은 덮지 않는다)
      const en = String(l.labelEn || '').trim();
      const rc = String(l.recipient || '').trim();
      if (field === 'labelEn' && (!rc || rc === en)) body.recipient = v;
      if (field === 'recipient' && !en) body.labelEn = v;
      this.busy = true;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/label', body);
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        await this.load();
      } catch (e) {
        console.error('营业执照 ' + field + ' 저장 실패:', e);
        alert('保存失败(저장 실패): ' + e.message);
      } finally {
        this.busy = false;
      }
    },
    async remove(l) {
      if (!confirm(l.companyid + ' · ' + (l.label || l.name) + ' — 删除营业执照?(사업자등록증을 삭제할까요?)')) return;
      this.busy = true;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/delete', { id: l._id });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '删除失败');
        this.$delete(this.thumbs, l._id);
        await this.load();
      } catch (e) {
        console.error('营业执照 삭제 실패:', e);
        alert('删除失败(삭제 실패): ' + e.message);
      } finally {
        this.busy = false;
      }
    },
    openBulk() {
      const checked = {};
      this.filtered.forEach(l => { checked[l._id] = true; });
      this.bulk = { show: true, email: '', targets: this.filtered.slice(), checked, preview: null, result: '', busy: false };
    },
    bulkTargetOf(id) { return this.bulk.targets.find(t => t._id === id) || {}; },
    bulkCheckAll(v) {
      const checked = {};
      this.bulk.targets.forEach(t => { checked[t._id] = !!v; });
      this.bulk.checked = checked;
    },
    // dryRun=true: 서버가 바뀔 목록만 계산(미리보기) / false: 적용. 규칙(중복·길이)은 서버 한 곳에 있다
    async bulkRun(dryRun) {
      if (!this.bulkEmailOk) return;
      const ids = this.bulkSelectedIds;
      if (!ids.length) return;
      this.bulk.busy = true;
      try {
        const { data } = await axios.post('/api/coupassInvoiceImage/label', { prependEmail: this.bulk.email, ids, dryRun });
        if (data.요청결과 !== '성공') throw new Error((data.error && data.error.errorMessage) || '保存失败');
        this.bulk.preview = { changes: data.changes || [], skipped: data.skipped || [] };
        if (!dryRun) {
          const skip = (data.skipped || []).length + (data.changes || []).length - (data.modified || 0);
          this.bulk.result = '已添加 ' + (data.modified || 0) + ' 张(추가 완료)' + (skip ? ' · 跳过 ' + skip + ' 张(건너뜀)' : '');
          await this.load();
        }
      } catch (e) {
        console.error('营业执照 邮箱 일괄 추가 실패:', e);
        alert((dryRun ? '预览失败(미리보기 실패): ' : '保存失败(저장 실패): ') + e.message);
      } finally {
        this.bulk.busy = false;
      }
    },
    fmtDate(v) {
      if (!v) return '';
      const d = new Date(v);
      return isNaN(d) ? '' : d.toLocaleString();
    }
  }
};
</script>

<style lang="scss" scoped>
.inv-lic {
  &__gap { gap: 8px; }
  &__rlabel { width: 48px; flex: none; }
  // 표가 길어도 머리행이 보이게(2026-10-04 YZY) — 표 상자 안에서 스크롤
  &__table {
    max-height: 70vh;
    overflow-y: auto;
    // 전역 .table 의 overflow:hidden 이 sticky 를 막는다(표가 스크롤 상자가 됨) → 여기서만 푼다(箱单发票 표와 같은 방식)
    table { overflow: visible; }
    thead th {
      position: sticky;
      top: 0;
      z-index: 2;
    }
  }
  &__table.inv-lic__bulk { max-height: 50vh; } // 일괄 추가 창 안의 표
  &__thumb {
    max-width: 80px;
    max-height: 60px;
    cursor: zoom-in;
    border: 1px solid #dee2e6;
  }
}
</style>
